import { render, staticRenderFns } from "./TestRouter2.vue?vue&type=template&id=7a490030"
import script from "./TestRouter2.vue?vue&type=script&lang=js"
export * from "./TestRouter2.vue?vue&type=script&lang=js"
import style0 from "./TestRouter2.vue?vue&type=style&index=0&id=7a490030&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports